import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ApiUrls } from 'src/app/core/helpers/api-urls';
import { Deal } from 'src/app/core/models/deal';
import { AbstractLoutyEntiteService } from 'src/app/core/services/abstract-louty-entite.service';
import { ToastMessagesService } from 'src/app/core/services/toast-messages.service';
import { MembreActivitesDto } from '../models/association-membre-activite-dto';

@Injectable({
  providedIn: 'root',
})
export class AssociationMembreActivitesService extends AbstractLoutyEntiteService<MembreActivitesDto, any> {
  protected getUrl = ApiUrls.getMembreActivitesUrl();
  protected duplicateUrl: string;
  protected getListUrl: string;
  protected saveUrl = ApiUrls.saveMembreActivitesUrl();
  protected saveListUrl: string;
  protected deleteUrl: string;
  protected deleteListUrl: string;
  protected getPaginatedListUrl: string;
  protected getIdNumeroDicoUrl: string;
  protected exportListToFileUrl: string;
  protected exportFileName: string;

  constructor(
    protected http: HttpClient,
    @Inject('API_BASE_URL') baseUrl: string,
    private toastMessagesService: ToastMessagesService,
  ) {
    super();
    this._apiBaseUrl = baseUrl;
  }

  public getDefaultActiviteDeal() {
    return new Deal<AbstractControl>({
      minCount: 1,
      maxCount: 1,
      check: (c: AbstractControl) => !!c.value?.actPrincipale,
      applyObjectiveVal: (c: AbstractControl, alert?: boolean) => {
        const val = c.value;
        val.actPrincipale = true;
        c.setValue(val);
        if (alert) {
          this.toastMessagesService.showWarning("Cette activité devient  l'activité principale.");
        }
      },
      applyAlternativeVal: (c: AbstractControl, alert?: boolean) => {
        const val = c.value;
        val.actPrincipale = false;
        c.setValue(val);
        if (alert) {
          this.toastMessagesService.showWarning("Changement d'activité principale.");
        }
      },
      warning: 'uneEtUneSeuleActivitePrincipale',
    });
  }
}
